import {Component, Input, OnInit} from '@angular/core';
import {DeviceProperty} from "../../../../../model/device-property";
import {DefaultDeviceCatalog} from "../../../../../model/default-device-catalog";

@Component({
  selector: 'app-default-device-properties',
  templateUrl: './default-device-properties.component.html',
  styleUrls: ['./default-device-properties.component.scss']
})
export class DefaultDevicePropertiesComponent implements OnInit {

  @Input()
  public defaultDeviceCatalog: DefaultDeviceCatalog;

  public properties: DeviceProperty[];
  public totalProperties: number;
  public loadingProperties: boolean;

  public rows = 10;
  public first = 0;

  constructor() {
    this.properties = [];
  }

  ngOnInit(): void {
    this.loadProperties();
  }

  private loadProperties(): void {
    this.loadingProperties = true;
    this.properties = this.defaultDeviceCatalog.content?.deviceProperties ? this.defaultDeviceCatalog.content.deviceProperties : [];
    this.totalProperties = this.properties.length;
    this.loadingProperties = false;
  }

}
